import { render, staticRenderFns } from "./DashboardCourse.vue?vue&type=template&id=3ac03521&"
import script from "./DashboardCourse.vue?vue&type=script&lang=ts&"
export * from "./DashboardCourse.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardCourse.vue?vue&type=style&index=0&id=3ac03521&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports